import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getIntegrityRowView } from "../Shared/Controller/projectReviewApp";
import { ShowToast } from "../common/CommonController";
import { ReviewContext } from "../context/ReviewContext";
import { Spinner } from "react-bootstrap";
import ConfirmModal from "../common/ConfirmModal";
import IntegrityViewRow from "../projects/IntegrityViewRow";

const IntegrityView = () => {
  let location = useLocation();
  let params = useParams();
  let navigate = useNavigate();

  const [RowData, setRowData] = useState({ SingleRow: {}, AllQuestions: {} });
  const [RowLoading, setRowLoading] = useState(false);
  const [saveRowLoading, setSaveRowLoading] = useState(false);
  const [isReviewFinish, setIsReviewFinish] = useState(false);
  const [showLastRowModal, setShowLastRowModal] = useState(false);
  const [nextId, setNextId] = useState("");

  useEffect(() => {
    let splitPath = location.pathname.split("/")
    if (splitPath.length > 2) {
      GetIntegrityRowView()
    }
  }, []);

  const checkLastRow = (next) => {
    if (RowData.SingleRow.id === RowData.SingleRow.last_row_id && next !== "") {
      setShowLastRowModal(true);
    }
    else {
      GetIntegrityRowView(next);
    }
  }

  const GetIntegrityRowView = (next = "") => {
    let data = {}
    data.projectid = params.project_id;

    if (next !== "") {
      data.nextid = nextId;
    }
    else {
      data.rowid = location.hash.replace("#", "");
    }
    setRowLoading(true);
    getIntegrityRowView(data).then((response) => {
      if (response.data.code === 1) {
        setRowData({ SingleRow: response.data.data });
        setNextId(response.data.data.id);
      }
      else {
        if (response.data.message.constructor === Object) {
          ShowToast("object", "error", response.data.message);
        }
        else {
          if (response.data.message === "No pending task.") {
            setIsReviewFinish(true);
            ShowToast("message", "info", response.data.message)
          }
          else {
            ShowToast("message", "error", response.data.message)
          }
        }
        setRowData({ SingleRow: {}, AllQuestions: {} });
      }
      setRowLoading(false);
    }).catch(error => {
      ShowToast("message", "error", "" + error);
    })
  }

  const onConfirmYesModal = () => {
    setShowLastRowModal(false);
    GetIntegrityRowView("next");
  }

  return (
    <React.Fragment>
      <div className="dashboard-card-wrapper reviewpage">
        <ConfirmModal show={showLastRowModal}
          customMessage={"You have reached end of the job"}
          showCancelButton={false}
          confirmBtnText="Ok"
          confirmClick={() => onConfirmYesModal()} />
        <ReviewContext.Provider value={{
          RowData,
          saveRowLoading,
          isReviewFinish,
          checkLastRow,
        }}>
          {RowLoading === false &&
            <IntegrityViewRow />
          }
          {RowLoading === true &&
            <>
              <div className="card">
                <div className="p-5 text-center">
                  <Spinner animation="border" size="lg" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              </div>
            </>
          }
        </ReviewContext.Provider>
      </div>
    </React.Fragment>
  )
}
export default IntegrityView;